import React, { useEffect, useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import { db } from '../firebase';
import { collection, updateDoc, doc, onSnapshot, query, orderBy, serverTimestamp } from 'firebase/firestore';
import { Search, Truck } from 'lucide-react';

const STATUS_OPTS = [
  { value: 'pending', label: 'Menunggu', color: '#94a3b8' },
  { value: 'proses', label: 'Diproses', color: '#d97706' },
  { value: 'distribusi', label: 'Sedang Dikirim', color: '#0369a1' },
  { value: 'selesai', label: 'Sudah Diterima', color: '#16a34a' },
];

export default function AdminDistribution() {
  const [donors, setDonors] = useState([]);
  const [couriers, setCouriers] = useState([]);
  const [search, setSearch] = useState('');
  const [toast, setToast] = useState(null);
  const [updating, setUpdating] = useState(null);

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast(null), 3000); };

  useEffect(() => {
    const u1 = onSnapshot(query(collection(db, 'donors'), orderBy('name', 'asc')), s => setDonors(s.docs.map(d => ({ id: d.id, ...d.data() }))));
    const u2 = onSnapshot(collection(db, 'couriers'), s => setCouriers(s.docs.map(d => ({ id: d.id, ...d.data() }))));
    return () => { u1(); u2(); };
  }, []);

  const updateDonor = async (id, field, value) => {
    setUpdating(id);
    const data = { [field]: value, updatedAt: serverTimestamp() };
    if (field === 'distributionStatus' && value === 'selesai') data.distributionDate = serverTimestamp();
    try {
      await updateDoc(doc(db, 'donors', id), data);
      showToast('Berhasil diperbarui');
    } catch (e) { showToast('Gagal update', 'error'); }
    setUpdating(null);
  };

  const filtered = donors.filter(d =>
    d.name?.toLowerCase().includes(search.toLowerCase()) ||
    d.address?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="page-header">
          <h1>Manajemen Distribusi</h1>
          <p>Update status distribusi daging ke setiap pengkurban dan assign kurir.</p>
        </div>

        {/* Stats */}
        <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', marginBottom: '1.5rem' }}>
          {STATUS_OPTS.map(s => (
            <div key={s.value} className="stat-card" style={{ borderTop: `3px solid ${s.color}` }}>
              <div className="stat-label">{s.label}</div>
              <div className="stat-value" style={{ color: s.color, fontSize: 22 }}>
                {donors.filter(d => (d.distributionStatus || 'pending') === s.value).length}
              </div>
            </div>
          ))}
        </div>

        <div style={{ position: 'relative', marginBottom: '1rem', maxWidth: 340 }}>
          <Search size={15} style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
          <input className="form-input" placeholder="Cari nama / alamat..." style={{ paddingLeft: 34 }}
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr><th>Nama</th><th>Alamat</th><th>Hewan</th><th>Cara Terima</th><th>Status</th><th>Assign Kurir</th><th>Aksi</th></tr>
            </thead>
            <tbody>
              {filtered.map(d => (
                <tr key={d.id} style={{ opacity: updating === d.id ? 0.6 : 1 }}>
                  <td style={{ fontWeight: 600 }}>{d.name}</td>
                  <td style={{ fontSize: 12, maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.address || '-'}</td>
                  <td><span style={{ fontSize: 13 }}>{d.animalType === 'sapi' ? '🐄' : '🐏'} {d.animalName || '-'}</span></td>
                  <td>
                    <span className="badge badge-gray" style={{ fontSize: 11 }}>{d.distributionMethod === 'ambil' ? '🏠 Ambil' : '🚚 Antar'}</span>
                  </td>
                  <td>
                    <select className="form-input form-select" style={{ padding: '5px 10px', fontSize: 13, minWidth: 140 }}
                      value={d.distributionStatus || 'pending'}
                      onChange={e => updateDonor(d.id, 'distributionStatus', e.target.value)}>
                      {STATUS_OPTS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                    </select>
                  </td>
                  <td>
                    {d.distributionMethod === 'antar' ? (
                      <select className="form-input form-select" style={{ padding: '5px 10px', fontSize: 13, minWidth: 130 }}
                        value={d.courierId || ''}
                        onChange={e => updateDonor(d.id, 'courierId', e.target.value)}>
                        <option value="">-- Pilih Kurir --</option>
                        {couriers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                      </select>
                    ) : (
                      <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Ambil sendiri</span>
                    )}
                  </td>
                  <td>
                    <button className="btn btn-sm" onClick={() => updateDonor(d.id, 'distributionStatus', 'selesai')}
                      disabled={d.distributionStatus === 'selesai' || updating === d.id}
                      style={{ background: '#dcfce7', color: '#166534', border: '1px solid #86efac', fontSize: 12 }}>
                      ✅ Selesai
                    </button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Belum ada data</td></tr>}
            </tbody>
          </table>
        </div>

        {toast && <div className="toast-container"><div className={`toast toast-${toast.type}`}>{toast.type === 'success' ? '✅' : '❌'} {toast.msg}</div></div>}
      </div>
    </div>
  );
}
